var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 -4.69723e-07 12 -1.04907e-06C5.373 -1.62842e-06 1.62842e-06 5.373 1.04907e-06 12C4.69723e-07 18.627 5.373 24 12 24ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM13 17C13.256 17 13.512 16.902 13.707 16.707L17.707 12.707C18.098 12.316 18.098 11.684 17.707 11.293L13.707 7.29297C13.316 6.90197 12.684 6.90197 12.293 7.29297C11.902 7.68397 11.902 8.31603 12.293 8.70703L14.5859 11L7 11C6.448 11 6 11.447 6 12C6 12.553 6.448 13 7 13L14.5859 13L12.293 15.293C11.902 15.684 11.902 16.316 12.293 16.707C12.488 16.902 12.744 17 13 17Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.fe33035a35991f62d6ef75c206a0dd38.svg";
export { ForwardRef as ReactComponent };